import Splide from '@splidejs/splide'

/*
const colorClasses = ['red', 'blue', 'yellow', 'green', 'pink']
let currentColorClass = colorClasses[Math.floor(Math.random() * colorClasses.length)]
let lastX = null,
    lastY = null
let mouseButtonDown = false

document.addEventListener('mousedown', (e) => {
    mouseButtonDown = true
    currentColorClass = colorClasses[Math.floor(Math.random() * colorClasses.length)]
})
document.addEventListener('mouseup', (e) => {
    mouseButtonDown = false
})

document.addEventListener('mousemove', (e) => {
    if (lastX !== null && lastY !== null && mouseButtonDown) {
        const trail = document.createElement('div')

        trail.className = `cursor-trail color-${currentColorClass}`
        document.body.appendChild(trail)

        // Calculate distance & angle between previous and current position
        const deltaX = e.clientX - lastX
        const deltaY = e.clientY - lastY
        const distance = Math.sqrt(deltaX ** 2 + deltaY ** 2)
        const angle = Math.atan2(deltaY, deltaX) * (180 / Math.PI)

        // Position and size the trail line
        trail.style.left = `${lastX}px`
        trail.style.top = `${lastY}px`
        trail.style.width = `${distance}px`
        trail.style.transform = `rotate(${angle}deg)`

        // Remove after fade-out animation
        setTimeout(() => trail.remove(), 500)
    }

    // Update last position
    lastX = e.clientX
    lastY = e.clientY
})
*/
new Splide('.splide', {
    type: 'loop',
    autoplay: true,
    speed: 1000,
}).mount()
